export default () => ({
    list: [],
    totalRevenue: 0
})
  